import React, { FC, SyntheticEvent, useState } from 'react'
import { Button } from 'transfix-ui/components/Button'
import { Box } from 'transfix-ui/core'
import { Checkbox } from 'components/forms'

interface IDayOfWeekFilterProps {
  value?: number[] | null
  onChange: (days?: number[] | null) => void
}

type TDayType = 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday'

interface IDayFilter {
  label: string
  value: number
}

const DAY_FILTER: Partial<Record<TDayType, IDayFilter>> = {
  monday: {
    label: 'Mondays',
    value: 1,
  },
  tuesday: {
    label: 'Tuesdays',
    value: 2,
  },
  wednesday: {
    label: 'Wednesdays',
    value: 3,
  },
  thursday: {
    label: 'Thursdays',
    value: 4,
  },
  friday: {
    label: 'Fridays',
    value: 5,
  },
  saturday: {
    label: 'Saturdays',
    value: 6,
  },
  sunday: {
    label: 'Sundays',
    value: 7,
  },
}

/** Flexible days filter */
export const DayOfWeekFilter: FC<IDayOfWeekFilterProps> = ({ onChange, value: valueProp }) => {
  const [selectedDays, setSelectedDays] = useState<IDayOfWeekFilterProps['value']>(valueProp || [])
  const dayNames = Object.keys(DAY_FILTER) as TDayType[]
  const dayHandler = (e: SyntheticEvent<HTMLInputElement>, day?: number | null) => {
    const selectedDaysState = selectedDays ? [...selectedDays] : []
    if (selectedDays && day) {
      if (selectedDays.includes(day)) {
        selectedDaysState.splice(selectedDaysState.indexOf(day), 1)
      } else {
        selectedDaysState.push(day)
      }
    }
    setSelectedDays(selectedDaysState)
  }
  const submitHandler = () => {
    onChange(selectedDays)
  }
  return (
    <Box>
      {dayNames.map(dayName => {
        const day = DAY_FILTER[dayName]
        const isChecked = selectedDays?.length ? selectedDays.includes(day?.value || 0) : false
        return (
          <Box paddingTop={1} key={day?.label}>
            <Checkbox
              label={day?.label}
              checked={isChecked}
              onChange={e => dayHandler(e, day?.value)}
            />
          </Box>
        )
      })}
      <Box mt={3}>
        <Button color='primary' size='large' fullWidth onClick={submitHandler}>
          Apply Filter
        </Button>
      </Box>
    </Box>
  )
}
